import { useEffect, useState } from "react";

import apiClient from "../utils/apiClient";

interface InitCheckProps {
  onInitStatusLoaded: (needsInitialization: boolean) => void;
}

export default function InitCheck({ onInitStatusLoaded }: InitCheckProps) {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkInitStatus = async () => {
      try {
        const response = await apiClient.get("/auth/init-status");
        onInitStatusLoaded(response.data.needsInitialization);
      } catch (err) {
        console.error(
          "Erreur lors de la vérification du statut d'initialisation:",
          err,
        );
        // En cas d'erreur, assume que l'initialisation est nécessaire
        onInitStatusLoaded(true);
      } finally {
        setLoading(false);
      }
    };

    checkInitStatus();
  }, [onInitStatusLoaded]);

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <div>Initialisation...</div>
      </div>
    );
  }

  return null;
}
